import { render, staticRenderFns } from "./PendingStoreOwnerApprovalCampaigns.vue?vue&type=template&id=6e909e2d&"
import script from "./PendingStoreOwnerApprovalCampaigns.vue?vue&type=script&lang=ts&"
export * from "./PendingStoreOwnerApprovalCampaigns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports